module.exports = __webpack_public_path__ + "static/media/logo-simplifica.7e796493.png";